<div class="create-page">
  <div class="create-card">
    <div class="create-body">

      <h2 class="page-title desktop-only-title">{{ pageTitle | translate }}</h2>

      <form [formGroup]="groupForm" class="setup-form">

        <div class="field-wrap">
          <input type="text"
                 class="text-input"
                 formControlName="name"
                 [placeholder]="'fee.group_name' | translate">
          @if (nameCtrl.touched && nameCtrl.hasError(formError.REQUIRED)) {
            <span class="field-error">{{ 'fee.validation.group_name_required' | translate }}</span>
          }
          @if (nameCtrl.touched && nameCtrl.hasError(formError.MAX_LENGTH)) {
            <span class="field-error">{{ 'fee.group_setup.maximum_25_characters' | translate }}</span>
          }
        </div>

        <button type="button" class="add-subgroup-link" (click)="addSubgroup()">
          + {{ 'fee.actions.add_subgroup' | translate }}
        </button>

        <div class="subgroups-list" formArrayName="subgroups">
          @for (sg of subgroups.controls; track sg; let i = $index) {
            <div class="subgroup-card"
                 [class.is-expanded]="subgroupMetas[i].expanded"
                 [class.is-collapsed]="!subgroupMetas[i].expanded"
                 [formGroupName]="i">

              <!-- Delete — absolute, top-right, outside grid -->
              <div class="btn-close-div">
                <button type="button" class="btn-close" (click)="removeSubgroup(i)">
                  <svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.54175 7.7085L1.4085 12.8417C1.24733 13.0029 1.05283 13.0835 0.825 13.0835C0.597333 13.0835 0.402917 13.0029 0.24175 12.8417C0.0805833 12.6806 0 12.4862 0 12.2585C0 12.0307 0.0805833 11.8362 0.24175 11.675L5.375 6.54175L0.24175 1.4085C0.0805833 1.24733 0 1.05283 0 0.825C0 0.597333 0.0805833 0.402916 0.24175 0.24175C0.402917 0.0805829 0.597333 0 0.825 0C1.05283 0 1.24733 0.0805829 1.4085 0.24175L6.54175 5.375L11.675 0.24175C11.8362 0.0805829 12.0307 0 12.2585 0C12.4862 0 12.6806 0.0805829 12.8417 0.24175C13.0029 0.402916 13.0835 0.597333 13.0835 0.825C13.0835 1.05283 13.0029 1.24733 12.8417 1.4085L7.7085 6.54175L12.8417 11.675C13.0029 11.8362 13.0835 12.0307 13.0835 12.2585C13.0835 12.4862 13.0029 12.6806 12.8417 12.8417C12.6806 13.0029 12.4862 13.0835 12.2585 13.0835C12.0307 13.0835 11.8362 13.0029 11.675 12.8417L6.54175 7.7085Z" fill="#ffffff"/>
                  </svg>
                </button>
              </div>

              <button type="button" class="btn-collapse" (click)="toggleSubgroup(i)"
                      [class.is-collapsed]="!subgroupMetas[i].expanded">
                <svg width="24" height="38" viewBox="0 0 24 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <mask id="mask0_13709_13063" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="14" width="24" height="24">
                    <rect y="14" width="24" height="24" fill="#D9D9D9"/>
                  </mask>
                  <g mask="url(#mask0_13709_13063)">
                    <path d="M8.2002 28C8.0502 28 7.92936 27.95 7.8377 27.85C7.74603 27.75 7.7002 27.6334 7.7002 27.5C7.7002 27.4667 7.7502 27.35 7.8502 27.15L11.4752 23.525C11.5585 23.4417 11.6419 23.3834 11.7252 23.35C11.8085 23.3167 11.9002 23.3 12.0002 23.3C12.1002 23.3 12.1919 23.3167 12.2752 23.35C12.3585 23.3834 12.4419 23.4417 12.5252 23.525L16.1502 27.15C16.2002 27.2 16.2377 27.2542 16.2627 27.3125C16.2877 27.3709 16.3002 27.4334 16.3002 27.5C16.3002 27.6334 16.2544 27.75 16.1627 27.85C16.071 27.95 15.9502 28 15.8002 28H8.2002Z" fill="#6B6C77"/>
                  </g>
                </svg>
              </button>

              @if (!subgroupMetas[i].expanded) {
                <div class="sg-collapsed-row">
                  <span class="sg-collapsed-summary">{{ getSubgroupControl(i, subgroupField.NAME).value || '—' }}</span>

                  <div class="sg-collapsed-details">
                  <div class="sg-data-col">
                    <span class="sg-data-label">{{ 'fee.subgroup_name' | translate }}</span>
                    <span class="sg-data-value">{{ getSubgroupControl(i, subgroupField.NAME).value || '—' }}</span>
                  </div>

                  <div class="sg-data-col">
                    <span class="sg-data-label">{{ 'fee.mentor_name' | translate }}</span>
                    <span class="sg-data-value">{{ getSubgroupControl(i, subgroupField.MENTOR_NAME).value || '—' }}</span>
                  </div>

                  <div class="sg-data-col">
                    <span class="sg-data-label">{{ 'fee.price' | translate }}</span>
                    <span class="sg-data-value">{{ getSubgroupControl(i, subgroupField.PRICE).value || '—' }} ֏</span>
                  </div>

                  <div class="sg-data-col">
                    <span class="sg-data-label">{{ 'fee.date_range' | translate }}</span>
                    <span class="sg-data-value">
                      @if (getSubgroupControl(i, subgroupField.START_DATE).value) {
                        {{ getSubgroupControl(i, subgroupField.START_DATE).value | date:'d.MM.yyyy' }}
                        @if (!isDailySinglePay(i) && getSubgroupControl(i, subgroupField.END_DATE).value) {
                          &ndash; {{ getSubgroupControl(i, subgroupField.END_DATE).value | date:'d.MM.yyyy' }}
                        }
                      } @else {
                        —
                      }
                    </span>
                  </div>
                  </div>
                </div>
              }

              @if (subgroupMetas[i].expanded) {
                <div class="sg-expanded-fields">

                <div class="field-wrap sg-span-2">
                  <input type="text" formControlName="name"
                         [placeholder]="'fee.subgroup_name' | translate" class="text-input">
                  @if (getSubgroupControl(i, subgroupField.NAME).touched && getSubgroupControl(i, subgroupField.NAME).hasError(formError.REQUIRED)) {
                    <span class="field-error">{{ 'fee.validation.enter_subgroup_name' | translate }}</span>
                  }
                  @if (getSubgroupControl(i, subgroupField.NAME).touched && getSubgroupControl(i, subgroupField.NAME).hasError(formError.MAX_LENGTH)) {
                    <span class="field-error">{{ 'fee.group_setup.maximum_25_characters' | translate }}</span>
                  }
                </div>
                <div class="field-wrap price-field-wrap">
                  <div class="price-row">
                    <input type="text" formControlName="price"
                           [placeholder]="'fee.price' | translate" min="1" class="text-input">
                    <mat-checkbox class="amount-edit-checkbox" color="primary" formControlName="allowCustomAmount">
                      <span class="amount-edit-label">{{ 'fee.allow_custom_amount' | translate }}</span>
                    </mat-checkbox>
                  </div>
                  @if (getSubgroupControl(i, subgroupField.PRICE).touched &&
                       (getSubgroupControl(i, subgroupField.PRICE).hasError(formError.REQUIRED) ||
                        getSubgroupControl(i, subgroupField.PRICE).hasError(formError.MIN) ||
                        getSubgroupControl(i, subgroupField.PRICE).hasError(formError.PATTERN))) {
                    <span class="field-error">{{ 'fee.validation.enter_valid_price' | translate }}</span>
                  }
                </div>

                <div class="field-wrap">
                  <input type="text" formControlName="mentorName"
                         [placeholder]="'fee.mentor_name_optional' | translate" class="text-input">
                </div>
                <div class="field-wrap">
                  <input type="tel" formControlName="mentorPhone"
                         [placeholder]="'fee.mentor_phone_optional' | translate" class="text-input">
                </div>
                <div class="field-wrap">
                  <input type="email" formControlName="mentorEmail"
                         [placeholder]="'fee.mentor_email_optional' | translate" class="text-input">
                  @if (getSubgroupControl(i, subgroupField.MENTOR_EMAIL).touched && getSubgroupControl(i, subgroupField.MENTOR_EMAIL).hasError(formError.EMAIL)) {
                    <span class="field-error">{{ 'fee.validation.invalid_email' | translate }}</span>
                  }
                </div>

                <div class="field-wrap sg-span-2">
                  <mat-form-field class="sg-date-field" appearance="fill">
                    @if (isDailySinglePay(i)) {
                      <input matInput [matDatepicker]="singlePicker" [min]="getSubgroupSingleMinDate(i)" formControlName="startDate" [placeholder]="'fee.date' | translate">
                      <mat-datepicker-toggle matIconSuffix [for]="singlePicker"></mat-datepicker-toggle>
                      <mat-datepicker #singlePicker></mat-datepicker>
                    } @else {
                      <mat-date-range-input [formGroup]="getSubgroupGroup(i)" [rangePicker]="picker" [min]="getSubgroupMinDate(i)">
                        <input matStartDate formControlName="startDate" [placeholder]="'fee.start_date' | translate">
                        <input matEndDate formControlName="endDate" [placeholder]="'fee.end_date' | translate">
                      </mat-date-range-input>
                      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-date-range-picker #picker></mat-date-range-picker>
                    }
                  </mat-form-field>
                  @if ((getSubgroupControl(i, subgroupField.START_DATE).touched && getSubgroupControl(i, subgroupField.START_DATE).hasError(formError.REQUIRED)) ||
                       (!isDailySinglePay(i) && getSubgroupControl(i, subgroupField.END_DATE).touched && getSubgroupControl(i, subgroupField.END_DATE).hasError(formError.REQUIRED))) {
                    <span class="field-error">{{ 'fee.validation.select_timeframe' | translate }}</span>
                  }
                  @if (getSubgroupControl(i, subgroupField.START_DATE).hasError('matDatepickerMin') ||
                       (!isDailySinglePay(i) && getSubgroupControl(i, subgroupField.END_DATE).hasError('matDatepickerMin'))) {
                    <span class="field-error">{{ 'fee.validation.date_in_past' | translate }}</span>
                  }
                  @if (getSubgroupControl(i, subgroupField.END_DATE).hasError('overpaymentExtendOnly')) {
                    <span class="field-error">{{ 'fee.validation.overpayment_extend_only' | translate }}</span>
                  }
                </div>
                <div class="field-wrap">
                  <mat-form-field class="sg-select-field" appearance="fill">
                    <mat-select formControlName="frequency" [placeholder]="'fee.frequency' | translate">
                      @for (opt of frequencyOptions; track opt.value) {
                        <mat-option [value]="opt.value">{{ opt.labelKey | translate }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>

                  <div class="field-wrap sg-span-full">
                    <mat-form-field class="sg-select-field" appearance="fill">
                      <mat-select formControlName="paymentFlow" [placeholder]="'fee.payment_flow' | translate">
                        @for (opt of paymentFlowOptions; track opt.value) {
                          <mat-option [value]="opt.value">{{ opt.labelKey | translate }}</mat-option>
                        }
                    </mat-select>
                  </mat-form-field>
                </div>

                <!-- Footer: Save Subgroup right-aligned, spans all 3 cols -->
                <div class="sg-footer">
                  <button type="button" class="btn-save-sg" (click)="saveSubgroup(i)">
                    {{ 'fee.save_subgroup' | translate }}
                  </button>
                </div>

                </div>
              }
            </div>
          }
        </div>

        <div class="form-footer">
          <button type="button" class="btn-cancel" (click)="cancel()">{{ 'Cancel' | translate }}</button>
          <button type="button" class="btn-save"
                  [disabled]="!canSave"
                  (click)="save()">
            {{ (saving ? 'fee.saving' : (isEditMode ? 'fee.group_setup.update' : 'user_card.save')) | translate }}
          </button>
        </div>

      </form>
    </div>
  </div>
</div>
